/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, FormattedHTMLMessage, FormattedNumber } from 'react-intl';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Signals from '../../../signals/Signals';
import PropertiesController from '../../../controllers/PropertiesController';

import { toCSV, toXLSX } from '../../../utils/exportToFile';

import ExpenseModel from '../../../stores/models/ExpenseModel';

import FileExports from '../../../components/ui/ToolTip/tooltips/FileExports';

import ModalAlert from '../../../components/ui/Modal/ModalAlert';

import Page from '../../Page';
import ExpenseRow from './components/ExpenseRow';
import SearchField from '../../../components/ui/SearchField/SearchField';

import AddButton from '../../../components/ui/AddButton/AddButton';
import { ApplicationContext } from '../../../ApplicationContext';
import FileUploadArea from '../../../components/ui/FileUploadArea/FileUploadArea';
import DraftTypes from '../../../data/DraftTypes';
import ExpenseDraftRow from './components/ExpenseDraftRow';
import ExpenseInputPanel from './components/modals/ExpenseInputPanel';
import { uniqueKey } from '../../../utils/ReactUtils';
import { EmptyRow } from '../../../components/ui/EmptyRow/EmptyRow';
import TableWrapper from '../../../components/ui/TableWrapper/TableWrapper';
import ToggleButton from '../../../components/ui/ToggleButton/ToggleButton';
import ToggleButtonOption from '../../../components/ui/ToggleButton/ToggleButtonOption';
import MoveDraftsToYearCommand from '../../../commands/drafts/MoveDraftsToYearCommand';

@observer
/**
 *
 */
class Expenses extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.addNew = this.addNew.bind(this);
		this.onSortClick = this.onSortClick.bind(this);
		this.onExportClick = this.onExportClick.bind(this);
		this.showExportTooltip = this.showExportTooltip.bind(this);
		this.onDeadlinesFetched = this.onDeadlinesFetched.bind(this);
		this.onFiles = this.onFiles.bind(this);
		this.update = this.update.bind(this);

		this.onDraftSelected = this.onDraftSelected.bind(this);
		this.onDraftDeselected = this.onDraftDeselected.bind(this);
		this.onMoveToBookyear = this.onMoveToBookyear.bind(this);

		this.fieldHeaderSettings = [
			{
				id: 'expenseNr',
				label: this.props.intl.formatMessage({ id: 'expenses.header.expensenr' }),
				minimal: true
			},
			{
				id: 'date',
				label: this.props.intl.formatMessage({ id: 'expenses.header.date' }),
				isDefault: true,
				minimal: true
			},
			{
				id: 'customerName',
				label: this.props.intl.formatMessage({ id: 'expenses.header.company' })
			},
			{
				id: 'description',
				label: this.props.intl.formatMessage({ id: 'expenses.header.subject' })
			},
			{
				id: 'ledgerCode',
				label: this.props.intl.formatMessage({ id: 'expenses.header.ledgercode' }),
				minimal: true
			},
			{
				id: 'btw',
				label: this.props.intl.formatMessage({ id: 'expenses.header.btw' }),
				center: true,
				minimal: true
			},
			{
				id: 'exclBTW',
				label: this.props.intl.formatMessage({ id: 'expenses.header.excl.btw' }),
				right: true,
				minimal: true
			},
			{
				id: 'inclBTW',
				label: this.props.intl.formatMessage({ id: 'expenses.header.incl.btw' }),
				right: true,
				minimal: true
			},
			{
				id: 'fileName',
				label: this.props.intl.formatMessage({ id: 'expenses.header.file' }),
				center: true,
				minimal: true
			},
			{
				id: 'state',
				label: this.props.intl.formatMessage({ id: 'expenses.header.state' }),
				center: true,
				minimal: true
			},
			{
				id: 'actions',
				label: this.props.intl.formatMessage({ id: 'expenses.header.actions' }),
				center: true,
				noSort: true,
				minimal: true
			}
		];

		this.state = { selectedDraftIds: [] };
	}

	/**
	 *
	 */
	componentWillMount() {
		Signals.CompanyChanged.add(this.update);
		Signals.FinancialYearChanged.add(this.update);
		Signals.DeadlinesFetched.add(this.onDeadlinesFetched);
		this.update();
	}

	/**
	 *
	 */
	componentWillUnmount() {
		Signals.CompanyChanged.remove(this.update);
		Signals.FinancialYearChanged.remove(this.update);
		Signals.DeadlinesFetched.remove(this.onDeadlinesFetched);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const applicationStore = this.context.applicationStore;
		const company = applicationStore.getSelectedCompany();
		const financialYear = applicationStore.getSelectedFinancialYear();

		if (!financialYear || !company) {
			return null;
		}

		const hasLockedDeadlines = applicationStore.yearResultStore.hasLockedDeadlines();
		const financialYearLocked = hasLockedDeadlines || !financialYear.isActive();

		const expenseStore = applicationStore.expenseStore;
		const draftsStore = company.draftsStore;
		const { selectedDraftIds } = this.state;

		// Create table headers
		const headers = this.fieldHeaderSettings.map((fieldData, index) => {
			if (fieldData.hide) return null;

			return (
				<td
					key={`ih-${index}`}
					className={`expenses__header--${fieldData.id.toLowerCase()} ${classNames({
						table__header: true,
						'table__header--minimal': fieldData.minimal,
						'table__header--sorted': expenseStore.sortBy === fieldData.id,
						'table__header--sorted-default table__header--sorted':
							!expenseStore.sortBy && fieldData.isDefault,
						'table__header--sorted-up':
							expenseStore.sortBy === fieldData.id && expenseStore.sortDirection === -1,
						'table__header--center': fieldData.center,
						'table__header--right': fieldData.right,
						'table__header--no-sort': fieldData.noSort
					})}`}
					onClick={() => this.onSortClick(fieldData.id)}>
					{fieldData.label}
				</td>
			);
		});

		// Create Draft rows
		const expenseDrafts = draftsStore.getDraftsOfType(DraftTypes.EXPENSE, financialYear.id);
		const draftRows = expenseDrafts.map((draft) => {
			return (
				<ExpenseDraftRow
					key={`exp-d-${draft.id}`}
					draft={draft}
					draftsStore={draftsStore}
					onSelect={this.onDraftSelected}
					onDeselect={this.onDraftDeselected}
				/>
			);
		});

		// Create table rows
		const rows = expenseStore.filteredAndSortedExpenses.map((expense) => {
			return (
				<ExpenseRow key={`i-${expense.id}`} expenseModel={expense} expenseStore={expenseStore} />
			);
		});

		// Check if year is active
		const classes = classNames({
			'expenses__year-inactive': !financialYear.isActive() || hasLockedDeadlines
		});
		const disabledProp = {};

		if (!financialYear.isActive() || hasLockedDeadlines) {
			disabledProp.disabled = true;
		}

		// Render page
		return (
			<Page pageName={`expenses ${classes}`}>
				{!financialYearLocked ? (
					<FileUploadArea className="walkthrough-step-expense" onChange={this.onFiles} />
				) : null}

				<div className="expenses__wrapper border border--dark">
					<div className="expenses__options box-shadow-small grid grid--spread">
						<div className="grid grid--no-wrap">
							<SearchField
								name="search"
								onChange={this.onSearch.bind(this)}
								placeholder={this.props.intl.formatMessage({ id: 'expenses.search' })}
								value={expenseStore.filter ? expenseStore.filter : undefined}
							/>

							{selectedDraftIds.length > 0 ? (
								<ToggleButton
									className=""
									onChange={this.onMoveToBookyear}
									label={this.props.intl.formatMessage({ id: 'label.moveto' })}
									options={company.financialYears
										.filter((fy) => fy.id !== financialYear.id)
										.map((fy) => {
											return new ToggleButtonOption(fy.year, fy.id, false);
										})}
								/>
							) : null}
						</div>

						<div className="grid expenses__options-buttons">
							<button
								type="button"
								className="icon icon--left icon--download2-black button--tertiary button--no-shadow expenses__export"
								onClick={this.showExportTooltip}>
								<FormattedMessage id="label.export" />
							</button>
							<button
								type="button"
								className="expenses__add-new icon icon--left icon--big-plus icon--color"
								onClick={this.addNew}
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...disabledProp}>
								<FormattedMessage id="expenses.add.expense" />
							</button>
						</div>
					</div>

					<TableWrapper scrollableX>
						<table className="table expenses__rows">
							<thead className="table__headers">
								<tr>{headers}</tr>
							</thead>
							<tbody className="table__body">
								{draftRows}
								{rows.length === 0 ? <EmptyRow /> : null}
								{rows}
							</tbody>
						</table>
					</TableWrapper>

					<div className="table__footer expenses__footer options-footer grid grid--spread border--top">
						<div>
							<div className="expenses__total_excld_vat">
								<FormattedMessage id="expense.add.total.excluding.vat" />
							</div>
							<FormattedNumber
								style="currency"
								currency="EUR"
								value={expenseStore.totalAmountExclBTW}
								minimumFractionDigits={2}
								maximumFractionDigits={2}
							/>
						</div>
						<div>
							<div className="expenses__total_incld_vat">
								<FormattedMessage id="expense.add.total.including.vat" />
							</div>
							<FormattedNumber
								style="currency"
								currency="EUR"
								value={expenseStore.totalAmountInclBTW}
								minimumFractionDigits={2}
								maximumFractionDigits={2}
							/>
						</div>
					</div>

					<AddButton
						onClick={this.addNew}
						title={this.props.intl.formatMessage({ id: 'expenses.add.expense' })}
						{...disabledProp}
					/>
				</div>
			</Page>
		);
	}

	/**
	 *
	 */
	onDeadlinesFetched() {
		const hasLockedDeadlines = this.context.applicationStore.yearResultStore.hasLockedDeadlines();
		if (hasLockedDeadlines) {
			Signals.ShowModal.dispatch(
				<ModalAlert
					title={this.props.intl.formatMessage({ id: 'alert.expenses.locked.deadline.title' })}
					body={this.props.intl.formatMessage({ id: 'alert.expenses.locked.deadline.description' })}
				/>
			);
		}
	}

	/**
	 *
	 * @param e
	 */
	onSearch(e) {
		this.context.applicationStore.expenseStore.filter = e ? e.target.value : null;
	}

	/**
	 *
	 * @param field
	 */
	onSortClick(field) {
		if (this.context.applicationStore.expenseStore.sortBy === field) {
			this.context.applicationStore.expenseStore.sortDirection =
				-this.context.applicationStore.expenseStore.sortDirection;
		} else {
			this.context.applicationStore.expenseStore.sortBy = field;
			this.context.applicationStore.expenseStore.sortDirection = 1;
		}
	}

	/**
	 *
	 * @param type
	 */
	onExportClick(type) {
		// Financial Year
		const financialYear = this.context.applicationStore.getSelectedFinancialYear();

		// Create headers
		let rows = [
			[
				this._getHeaderLabel('expenseNr'), // A
				this._getHeaderLabel('date'), // B
				this._getHeaderLabel('customerName'), // C
				this._getHeaderLabel('description'), // D
				this._getHeaderLabel('projectcode'), // E
				this._getHeaderLabel('state'), // F
				this._getHeaderLabel('ledgerCode'), // G
				this._getHeaderLabel('btw'), // H
				this._getHeaderLabel('inclBTW'), // I
				this._getHeaderLabel('exclBTW')
			] // J
		];

		// Generate data
		const expenseStore = this.context.applicationStore.expenseStore;
		expenseStore.filteredAndSortedExpenses.forEach((expenseModel) => {
			rows = rows.concat(expenseModel.toArray(this.props.intl, financialYear.year));
		});

		// Format incl/excl btw column
		const formats = [
			{ column: 'I', format: '#,##0.00;(#,##0.00)' },
			{ column: 'J', format: '#,##0.00;(#,##0.00)' }
		];

		// Export
		switch (type) {
			case 'csv':
				toCSV(rows, this.props.intl.formatMessage({ id: 'submenu.expenses' }), formats);
				break;
			case 'xlsx':
				toXLSX(rows, this.props.intl.formatMessage({ id: 'submenu.expenses' }), formats);
				break;
			default:
				toCSV(rows, this.props.intl.formatMessage({ id: 'submenu.expenses' }), formats);
		}
	}

	/**
	 *
	 * @param files
	 */
	onFiles(files) {
		const { applicationStore } = this.context;
		const { draftsFileUploadStore } = applicationStore;

		// Set types and targets
		draftsFileUploadStore.draftTarget = applicationStore.getSelectedCompany();
		draftsFileUploadStore.draftType = DraftTypes.EXPENSE;

		const financialYear = applicationStore.getSelectedFinancialYear();

		for (let i = 0; i < files.length; i++) {
			draftsFileUploadStore.add(files[i], financialYear.id);
		}
	}

	/**
	 *
	 * @param draft
	 */
	onDraftSelected(draft) {
		this.state.selectedDraftIds.push(draft.id);
		this.forceUpdate();
	}

	/**
	 *
	 * @param draft
	 */
	onDraftDeselected(draft) {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const selectedDraftIds = this.state.selectedDraftIds.filter((id) => {
			return draft.id !== id;
		});

		this.setState({ selectedDraftIds });
	}

	/**
	 *
	 */
	onMoveToBookyear(financialYearId) {
		const { applicationStore } = this.context;
		const { selectedDraftIds } = this.state;

		const currentFinancialYear = applicationStore.getSelectedFinancialYear();
		const company = applicationStore.getSelectedCompany();
		const toFinancialYear = company.getFinancialYearById(parseInt(financialYearId, 10));

		const command = new MoveDraftsToYearCommand(
			company.draftsStore,
			selectedDraftIds,
			currentFinancialYear.id,
			toFinancialYear.id
		);
		command.execute(() => {
			Signals.ShowMessageDialog.dispatch(
				<FormattedHTMLMessage
					id="draft.moved.message"
					values={{ count: selectedDraftIds.length, year: toFinancialYear.year }}
				/>
			);
			this.setState({ selectedDraftIds: [] });
		});
	}

	/**
	 *
	 * @param e
	 */
	showExportTooltip(e) {
		e.preventDefault();
		Signals.ShowToolTip.dispatch(<FileExports onSelect={this.onExportClick} />, e.target, 16);
	}

	/**
	 *
	 */
	update() {
		const financialYear = this.context.applicationStore.getSelectedFinancialYear();

		if (financialYear) {
			this.setState({ selectedDraftIds: [] });
			this.context.applicationStore.yearResultStore.fetchDeadlines(financialYear.id);
			this.context.applicationStore.financialStatementStore.fetch(financialYear.id);
			this.context.applicationStore.expenseStore.fetch(financialYear.id);
		}

		this.forceUpdate();
	}

	/**
	 *
	 */
	addNew() {
		// Show ExpenseInputPanel overlay
		Signals.ShowOverlay.dispatch(
			<ExpenseInputPanel key={uniqueKey('eip-')} expenseModel={ExpenseModel.createNewExpense()} />
		);
	}

	/**
	 *
	 * @param field
	 * @return {*}
	 * @private
	 */
	_getHeaderLabel(field) {
		const result = this.fieldHeaderSettings.find((fieldData) => {
			return fieldData.id === field;
		});

		return result ? result.label : field;
	}
}

Expenses.contextType = ApplicationContext;

Expenses.propTypes = {
	intl: PropTypes.object
};

export default injectIntl(Expenses);
